import { useSearchParams } from "react-router-dom";
// @mui material components
import {
  CircularProgress,
  Backdrop,
  Grid,
  ButtonGroup,
  Button,
  Box,
  SwipeableDrawer,
  styled,
  Typography,
  Skeleton,
  CssBaseline,
  Paper,
  Link,
  Card,
  Chip,
  CardContent,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";
import { IconButton } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import { Global } from '@emotion/react';
import { grey } from '@mui/material/colors';
import DownloadIcon from '@mui/icons-material/Download';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { mutate } from "swr";

// Interpretation dashboards components
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { Document, Page, pdfjs } from "react-pdf";
import { useEffect, useRef, useState } from "react";
import { Panel, PanelGroup } from "react-resizable-panels";
import PanelResizeHandle from "hooks/ResizeHandler";
import PagingControl from "components/PagingControl";
import panelStyles from "panel-style.module.css";
import dayjs from "dayjs";
import { useNavigate, useLocation, useParams } from "react-router-dom";
// Data
import Label from "components/label/Label";
import CustomInputLabel from "components/custom-input-label";
import CustomReportInputForm from "layouts/report-input-form/custom-report-input-form";
import { downloadFromURI, base64ToBlob, viewBlobFile } from "utils/Utils";
import {
  getEcgReportAndData, useGetEcgGraph, useGetEcgData, useCollectionsData
} from "api/reports";
import { saveDataInterpretation, saveInterpretationReplica } from "api/reports";
import { useSnackbar } from '../components/snackbar'
import useResponsive from "hooks/useResponsive";
import { useAuthDispatch } from 'components/AuthStateProvider';

import TatTimerChip from "utils/TatTimerChip";
import LeadQualityClassification from "components/LeadQualityClassification";
import SVGViewer from "components/SVGViewer";


pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const drawerBleeding = 54;

const sliderStyle = {
  position: "absolute",
  bottom: 5,
  right: 5,
  background: "rgba(0,0,0,0.1)",
  padding: "8px 8px",
  borderRadius: "10px",
  display: "flex",
  alignItems: "center",
  gap: "10px",
  backdropFilter: "blur(6px)",
};
const Root = styled('div')(({ theme }) => ({
  height: '100%',
  backgroundColor:
    theme.palette.mode === 'light' ? grey[100] : theme.palette.background.default,
}));

const StyledBox = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'light' ? '#fff' : grey[800],
}));

const Puller = styled('div')(({ theme }) => ({
  width: 30,
  height: 6,
  backgroundColor: theme.palette.mode === 'light' ? grey[300] : grey[900],
  borderRadius: 3,
  position: 'absolute',
  top: 8,
  left: 'calc(50% - 15px)',
}));

const props = { window: () => Window }

function Custominterpretation(props) {
  const VIEWER_HEIGHT = "60vh"; // responsive height

  ////////////////////////////////////////////////////////////
  const [viewMode, setViewMode] = useState("svg"); // default SVG
  const [zoom, setZoom] = useState(1);
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const LeadTrace = searchParams.get("leadTrace") === "true";
  const replicaInterpret = searchParams.get("replica") === "true";
  const { id } = useParams();
  // const { ecgGraph, isLoading: isLoadingGraph } = useGetEcgGraph(  { argEcg:false }, id );
  // const { ecgData, isLoading, mutate } = useGetEcgData(
  //   !replicaInterpret ? { argEcg: false } : null,
  //   !replicaInterpret ? id : null
  // );
  // const {
  //   replicaInterpretationData,
  //   isLoading: isLoadingReplica
  // } = useGetReplicaInterpretationData(
  //   replicaInterpret
  //     ? { id, replicadata: true }
  //     : null
  // );

  // const reportresponse = replicaInterpret
  //   ? replicaInterpretationData
  //   : ecgData;

  // const loadingPDF = replicaInterpret
  //   ? isLoadingReplica
  //   : isLoading;
  // const { ecgGraph } = useGetEcgGraph({ argEcg: false },id);
  const params = replicaInterpret
    ? { replicadata: true }
    : { argEcg: false };

  const {
    ecgData: reportresponse,
    isLoading: loadingPDF,
    mutate
  } = useGetEcgData(params, id);


  const { collectionData, isLoading: isCollectionLOading } = useCollectionsData(id);
  const { socket, getSocketValue } = useAuthDispatch()
  const { account } = useAuthDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const isLg = useResponsive('up', 'md');
  const isMd = useResponsive('between', 'sm', 'md');
  // edit pdf
  const documentRef = useRef(null);
  const [allFilesData, setAllFilesData] = useState();
  const [renderedFileIndex, setRenderedFile] = useState(0);
  const [pdf, setPdf] = useState();
  const [importError, setImportError] = useState("");
  const [pageNum, setPageNum] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [renderAllPages, setRenderAllPages] = useState(false);
  const [pdfScale, setPdfScale] = useState(isLg || isMd ? 1 : 0.5);
  const [loading, setLoading] = useState(false);

  const [openInterpretationRevokeDialog, setOpenInterpretationRevokeDialog] = useState(false);
  const [interpretationRevokeData, setInterpretationRevokeData] = useState({ reportId: null, message: "" });
  const [loadingdata, setLoadingdata] = useState(loadingPDF);

  useEffect(() => {
    if (reportresponse) {
      setPdf(`data:application/pdf;base64,${reportresponse?.ReportPdf}`);
      setAllFilesData(reportresponse || {});
      setLoadingdata(false)
    }
  }, [loadingPDF, reportresponse])

  useEffect(() => {

    //-------- Here we receive the socket notification wherever any new interpretation request comming
    socket.on('addReport', (result) => {
      if (result) {
        enqueueSnackbar("New Interpretation request received", { variant: 'info' })
      }
    })

    //for 4min revoke warning 
    socket.on('showPopup', ({ reportId, message }) => {
      openInterpretationDialog(reportId, message);
    })

    socket.on("autoRevoked", ({ message }) => {
      enqueueSnackbar(message, { variant: "warning" });
      navigate(`${process.env.REACT_APP_HOMEPAGE}dashboard/allReports`);
    });

    // return () => {
    //   clearTimeout(timer);
    // };

  }, []);


  useEffect(() => {
    try {
      const sourceDetails = JSON.parse(allFilesData?.meta_data || "{}");

      if (sourceDetails?.source?.includes("BPL")) {
        setViewMode("pdf");
      } else {
        setViewMode("svg");
      }
    } catch (e) {
      console.error("Invalid meta_data JSON");
    }
  }, [allFilesData]);
  /////////////////////////////////////////////////
  const styles = {
    dropContainer: {},
    container: {
      display: "flex",
      width: "100%",
      justifyContent: "center",
    },
    sigBlock: {
      display: "inline-block",
    },
    documentBlock: {
      // maxWidth: 800,
      margin: "0px",
      marginTop: 5,
      // border: "1px solid #999",
      display: "flex",
      width: "100%",
      justifyContent: "center",
      overflow: "auto"
    },
    controls: {
      backgroundColor: "#ffff",
      // maxWidth: 800,
      margin: "10px",
      display: "flex",
      justifyContent: "space-between",
      position: "sticky",
      zIndex: 2,
      width: "100%"
    },

    labelStyle: {
      color: "text.secondary",
      fontWeight: 600,
      fontSize: "14px",
      letterSpacing: "0.4px"
    },
    valueStyle: {
      fontWeight: 700,
      fontSize: "13px"
    },
    gridLayout: {
      display: "grid",
      gridTemplateColumns: {
        xs: "repeat(2, 1fr)",
        sm: "repeat(3, 1fr)",
        md: "repeat(4, 1fr)",
        lg: "repeat(4, 1fr)", // change from 6 → 4
      },
      gap: 3,
    }
  };

  //Handle form submit
  const handleReportInputFormSubmit = async (event, formInput) => {
    event.preventDefault();
    const { prescription_data, ...restFormInput } = formInput;
    const ppInterval = Number(formInput.pp_interval);
    const rrInterval = Number(formInput.rr_interval);

    const atrial_rate =
      ppInterval && ppInterval > 0 ? Math.round(60000 / ppInterval) : null;

    const ventricular_rate =
      rrInterval && rrInterval > 0 ? Math.round(60000 / rrInterval) : null;

    if (atrial_rate !== null) {
      restFormInput.atrial_rate = atrial_rate;
    }

    if (ventricular_rate !== null) {
      restFormInput.ventricular_rate = ventricular_rate;
    }

    const dataToUpdate = {
      ...restFormInput,
      name: `${formInput["first_name"]}${formInput["last_name"]}`,
      completed_at: allFilesData?.completed_at || new Date(),
      ...(collectionData?.symptoms?.length && {
        any_symptom: collectionData.symptoms.join(", ")
      })
    };
    const bodyData = {
      id: allFilesData?.id,
      interpretationFormData: dataToUpdate,
      prescription: prescription_data
    };
    const updateInterpretationData = async () => {
      try {
        const callUrl = replicaInterpret ? saveInterpretationReplica : saveDataInterpretation;
        const response = await callUrl({
          bodyData
        });

        if (response && response?.status === 200 && response?.data) {
          const reportdata = response?.data;
          const fetchedPdfData = reportdata?.ReportPdf;
          delete reportdata.ReportPdf;
          const URL = `data:application/pdf;base64,${fetchedPdfData}`;
          setPdf(URL);
          await mutate();
          enqueueSnackbar(response.message, { variant: 'success' })
         
          // if (reportdata?.interpretation_data) setAllFilesData((previousStatus) => [{ ...previousStatus, interpretation_data: reportdata?.interpretation_data }]);
          if (reportdata?.interpretation_data) setAllFilesData((previousStatus) => ({
            ...previousStatus,
            interpretation_data: reportdata?.interpretation_data,
          }));
        } else {
          enqueueSnackbar(response.message, { variant: 'error' })
        }
      } catch (error) {
        console.error("Error updating interpretation data:", error);
      }
    };
    await updateInterpretationData();
  }
  const openInterpretationDialog = (reportId, message) => {
    setInterpretationRevokeData({
      reportId,
      message: message || "Are you still working on this report?"
    });
    setOpenInterpretationRevokeDialog(true);
  };

  const handleContinue = () => {

    socket.emit("extendInterpretation",
      account?.authorization,
      interpretationRevokeData.reportId

    );

    setOpenInterpretationRevokeDialog(false);
  };

  const handleExit = () => {

    socket.emit("revokeInterpretation", interpretationRevokeData.reportId,
    );

    setOpenInterpretationRevokeDialog(false);
    navigate(`${process.env.REACT_APP_HOMEPAGE}dashboard/allReports`);
  };

  const handleShareClick = async (e) => {
    const reportPdf = await handleReportInputFormSubmit(e, allFilesData);
    setLoading(true);
    if (reportLink["url"]) {

      const pdfLink = reportLink["url"];
      // Create the WhatsApp message with the PDF link
      const message = encodeURIComponent(
        `Dear ${allFilesData["FirstName"]},\n\nYour ECG reports is now generated.\nClick here to download - \n${pdfLink}\n\n*Thanks*,\n*Team Spandan ECG*.\nwww.spandan.in`
      );

      // Open WhatsApp with the pre-filled message
      window.open("https://wa.me/?text=" + message, "_balnk");
    } else console.error(reportLink["error"]);
    setLoading(false);
  };

  function downloadURI(uri) {
    const reportdata = allFilesData;
    const fileName = `${reportdata?.user_data?.first_name}${reportdata?.user_data?.last_name ? "-" + reportdata?.user_data?.last_name : ''}-${dayjs(reportdata?.report_timestamp).format('DD-MM-YYYY-HH-mm')}${reportdata?.interpretation_data?.report_status ? `-${reportdata?.interpretation_data?.report_status}` : ''}.pdf`;
    downloadFromURI(uri, fileName)
    enqueueSnackbar("pdf downloading successfully", { variant: 'success' })
  }

  const viewOriginalReport = (id) => async (e) => {
    try {
      setLoadingdata(true)
      const reportresponse = await getEcgReportAndData({
        id
      })
      const reportdata = reportresponse?.data;
      const fetchedPdfData = reportdata?.ReportPdf;
      delete reportdata?.ReportPdf;
      if (!reportdata || !fetchedPdfData) {
        return setImportError("Unable to download. Please try again.");
      }
      const uri = `data:application/pdf;base64,${fetchedPdfData}`;
      const fileName = `ecg-report-${reportdata?.user_data?.first_name}${reportdata?.user_data?.last_name ? `-${reportdata?.user_data?.last_name}` : ''}-${dayjs(reportdata?.report_timestamp).format('DD-MM-YYYY-HH-mm')}${reportdata?.interpretation_data?.report_status ? `-${reportdata?.interpretation_data?.report_status}` : ''}.pdf`;
      downloadFromURI(uri, fileName)
      enqueueSnackbar("pdf downloading successfully", { variant: 'success' })
      setLoadingdata(false)

      // const blobFile = await base64ToBlob(`data:application/pdf;base64,${fetchedPdfData}`);
      // viewBlobFile(blobFile);

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const handleBackClick = (e) => {
    setPdf(null);
    setTotalPages(0);
    setPageNum(0);
    setAllFilesData([]);
    setImportError("");
    setLoading(false);
    setRenderedFile(0);
    navigate(-1);

  };


  // const handleZoom = (scale) => {
  //   setPdfScale(scale <= 1 ? (isLg ? 1 : 0.5) : scale)
  // };

  const { window } = props;
  const [open, setOpen] = useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const container = window !== undefined ? () => window().document.body : undefined;



  return (
    <Root>
      <CssBaseline />
      <Global
        styles={{
          '.MuiDrawer-root > .MuiPaper-root': {
            height: `calc(90% - ${drawerBleeding}px)`,
            overflow: 'visible',
          },
          [`.${panelStyles.PanelPdf}`]: {
            overflow: 'auto !important'
          },
          [`.${panelStyles.Panel}`]: {
            overflow: 'auto !important',
          },
        }}
      />
      <Grid mt={1}>
        {loadingdata ? (
          <Box
            sx={{
              height: "80vh",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              gap: 2
            }}
          >
            <CircularProgress size={40} />

            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ letterSpacing: "0.3px" }}
            >
              Loading report...
            </Typography>
          </Box>
        ) : (
          <Grid item xs={12} lg={12}>
            {pdf ?
              (
                <PanelGroup direction="horizontal" className={panelStyles.PanelGroup} >
                  <Panel defaultSize={isLg ? 55 : 100} minSize={isLg ? 48 : 100} maxSize={isLg ? 60 : 100} className={panelStyles.PanelPdf} >
                    <div>
                      <div style={{ ...styles.controls, alignItems: 'center' }}>
                        <ButtonGroup variant="outlined" aria-label="outlined button group">
                          <Button size="small"
                            onClick={handleBackClick}
                            startIcon={<ArrowBackIcon />}>
                            Back
                          </Button>
                          {pdf ? (
                            (allFilesData) &&
                              allFilesData["id"] ? (
                              <>
                                <Button size="small"
                                  onClick={() => {
                                    downloadURI(pdf);
                                  }}
                                  startIcon={<DownloadIcon />}>
                                  Download
                                </Button>
                              </>
                            ) : (
                              ""
                            )
                          ) : null}

                        </ButtonGroup>
                        {allFilesData && (
                          <TatTimerChip
                            row={{
                              ...allFilesData,
                              interpretation_requested_at:
                                allFilesData?.interpretation_requested_at ||
                                allFilesData?.interpretation_data?.requested_at
                            }}
                          />
                        )}

                        <Link variant="subtitle2" onClick={viewOriginalReport(id)} sx={{ cursor: 'pointer' }}>
                          Download app report
                        </Link>

                        <div>
                          {!renderAllPages ? (
                            <PagingControl
                              className={panelStyles.PanelControl}
                              pageNum={pageNum}
                              setPageNum={setPageNum}
                              totalPages={totalPages}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div ref={documentRef} style={{ ...styles.documentBlock, flexDirection: 'column', alignItems: 'center' }}>
                        <div
                          style={{
                            position: "relative",
                            overflow: "hidden",
                            height: VIEWER_HEIGHT,
                            width: "100%",
                            background: "#fff",
                          }}
                        >
                          {loadingPDF || !reportresponse?.svgGraph ? (
                            //  SKELETON (FULL HEIGHT - NO JUMP)
                            <Box sx={{ width: "100%", height: "100%" }}>
                              <Skeleton
                                animation="wave"
                                variant="rectangular"
                                width="100%"
                                height="100%"
                                sx={{ borderRadius: 2 }}
                              />
                            </Box>
                          ) : (
                            <TransformWrapper
                              initialScale={1}
                              minScale={1}
                              maxScale={3}
                              wheel={{ smoothStep: 0.02 }}
                              pinch={{ step: 5 }}
                              onTransformed={(ref) => {
                                setZoom(ref.state.scale);
                              }}
                            >
                              {({ setTransform }) => (
                                <>
                                  <TransformComponent
                                    wrapperStyle={{
                                      width: "100%",
                                      height: "100%",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center", //  prevents jump feel
                                    }}
                                  >
                                    {/* 👇 SWITCH VIEW */}
                                    {viewMode === "pdf" ? (
                                      <Document
                                        file={pdf}
                                        onLoadSuccess={(data) => {
                                          setTotalPages(data.numPages);
                                          //setPageNum(data.numPages > 1 ? 1 : 0);
                                          setPageNum(data.numPages > 1 ? (data.numPages === 3) ? 0 : 1 : 0);
                                        }}
                                      >
                                        <Page
                                          renderAnnotationLayer={false}
                                          renderTextLayer={false}
                                          pageNumber={pageNum + 1}
                                          width={800} //  fixed width for consistency
                                        />
                                      </Document>
                                    ) : (
                                      <div style={{ width: 800 }}>
                                        <SVGViewer
                                          svgGraph={reportresponse?.svgGraph}
                                          documentRef={null}
                                          enableZoom={false} // ❗ prevent double zoom
                                        />
                                      </div>
                                    )}
                                  </TransformComponent>

                                  {/*  TOGGLE SWITCH */}
                                  <Box
                                    sx={{
                                      position: "absolute",
                                      bottom: 10,
                                      right: 10,
                                      zIndex: 20,
                                      width: 100,
                                      height: 36,
                                      background: "rgba(30,30,30,0.9)",
                                      borderRadius: "30px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                      px: 1,
                                      cursor: "pointer",
                                      backdropFilter: "blur(6px)",
                                    }}
                                    onClick={() => {
                                      const newMode = viewMode === "svg" ? "pdf" : "svg";
                                      setViewMode(newMode);

                                      //  reset zoom on switch (optional but clean UX)
                                      setZoom(1);
                                      setTransform(0, 0, 1, 100);
                                    }}
                                  >
                                    {/* Sliding Indicator */}
                                    <Box
                                      sx={{
                                        position: "absolute",
                                        top: 4,
                                        left: viewMode === "svg" ? 4 : 52,
                                        width: 40,
                                        height: 28,
                                        background: "#1976d2",
                                        borderRadius: "20px",
                                        transition: "all 0.3s ease",
                                      }}
                                    />

                                    <IconButton size="small" sx={{ zIndex: 1, color: "#fff" }}>
                                      <ShowChartIcon fontSize="small" />
                                    </IconButton>

                                    <IconButton size="small" sx={{ zIndex: 1, color: "#fff" }}>
                                      <PictureAsPdfIcon fontSize="small" />
                                    </IconButton>
                                  </Box>

                                  {/*  ZOOM SLIDER */}
                                  <div
                                    style={{
                                      position: "absolute",
                                      bottom: 10,
                                      left: 10,
                                      zIndex: 20,
                                      background: "rgba(0,0,0,0.4)",
                                      padding: "6px 10px",
                                      borderRadius: 8,
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 10,
                                      backdropFilter: "blur(6px)",
                                    }}
                                  >
                                    <input
                                      type="range"
                                      min={1}
                                      max={3}
                                      step={0.05}
                                      value={zoom}
                                      onChange={(e) => {
                                        const newZoom = parseFloat(e.target.value);
                                        setZoom(newZoom);
                                        setTransform(0, 0, newZoom, 100);
                                      }}
                                    />
                                    <span style={{ color: "#fff", fontSize: 12 }}>
                                      {Math.round(zoom * 100)}%
                                    </span>
                                  </div>
                                </>
                              )}
                            </TransformWrapper>
                          )}
                        </div>

                        {/* <Box> */}
                        <Box
                          sx={{
                            width: "100%",
                            maxWidth: "750px",
                            mx: "auto"
                          }}
                        >


                          <Box
                            sx={{
                              background: "#ffffff",
                              p: 2,
                              borderRadius: "8px",
                              minHeight: "18%",
                              m: 2,
                            }}
                          >
                            <Typography variant="h6" fontWeight="600" mb={2}>
                              Test Summary
                            </Typography>

                            {/* <Box display="flex" flexWrap="wrap"  alignItems= "center" gap={4}> */}
                            <Box sx={styles.gridLayout}>
                              <Box>
                                <Typography sx={styles.labelStyle}>Name</Typography>
                                <Typography sx={styles.valueStyle}>
                                  {allFilesData?.user_data?.first_name || "—"}{" "}
                                  {allFilesData?.user_data?.last_name || ""}
                                </Typography>
                              </Box>

                              <Box>
                                <Typography sx={styles.labelStyle}>Patient Id</Typography>
                                <Typography sx={styles.valueStyle} >
                                  {allFilesData?.user_data?.patient_id || "—"}

                                </Typography>
                              </Box>

                              <Box>
                                <Typography sx={styles.labelStyle}>AGE</Typography>
                                <Typography sx={styles.valueStyle} >
                                  {allFilesData?.user_data?.display_age || "—"}
                                </Typography>
                              </Box>

                              <Box>
                                <Typography sx={styles.labelStyle}>GENDER</Typography>
                                <Typography sx={styles.valueStyle}>
                                  {allFilesData?.user_data?.gender || "—"}
                                </Typography>
                              </Box>

                              <Box>
                                <Typography sx={styles.labelStyle}>CENTRE</Typography>
                                <Typography sx={styles.valueStyle} >
                                  {collectionData?.center?.name || collectionData?.center?.business_name || "—"}
                                </Typography>
                              </Box>

                            </Box>

                          </Box>


                          {(collectionData?.body_vitals || allFilesData?.vitals) && (
                            <Box
                              sx={{
                                background: "#ffffff",
                                p: 2,
                                borderRadius: "8px",
                                minHeight: "18%",
                                m: 2,
                              }}
                            >
                              <Typography variant="h6" fontWeight="600" mb={2}>
                                Patient Vitals
                              </Typography>

                              <Box sx={styles.gridLayout}>
                                {/* <Box display="flex" flexWrap="wrap"  alignItems= "center" gap={4}> */}
                                {/* Height */}
                                <Box>
                                  <Typography sx={styles.labelStyle}>
                                    HEIGHT
                                  </Typography>
                                  <Typography sx={styles.valueStyle}>
                                    {allFilesData?.user_data?.height
                                      ? `${Math.round(allFilesData?.user_data?.height)} cm`
                                      : "-"}
                                  </Typography>
                                </Box>

                                {/* Weight */}
                                <Box>
                                  <Typography sx={styles.labelStyle}>
                                    WEIGHT
                                  </Typography>
                                  <Typography sx={styles.valueStyle}>
                                    {allFilesData?.user_data?.weight
                                      ? ` ${allFilesData?.user_data?.weight} kg `
                                      : "-"
                                    }
                                  </Typography>
                                </Box>

                                {/* SPO2 */}
                                <Box>
                                  <Typography sx={styles.labelStyle}>
                                    SPO2
                                  </Typography>
                                  <Typography sx={styles.valueStyle}>
                                    {collectionData?.body_vitals
                                      ? collectionData?.body_vitals?.spo2?.value
                                        ? `${collectionData.body_vitals.spo2.value} ${collectionData.body_vitals.spo2.unit}`
                                        : "-"
                                      : `${allFilesData?.vitals?.patient_sp02} %` || "-"}
                                  </Typography>
                                </Box>

                                {/* BP */}
                                <Box>
                                  <Typography sx={styles.labelStyle}>
                                    BP
                                  </Typography>
                                  <Typography sx={styles.valueStyle} >
                                    {collectionData?.body_vitals
                                      ? (collectionData?.body_vitals?.blood_pressure.systolic || collectionData?.body_vitals?.blood_pressure.diastolic)
                                        ? `${collectionData.body_vitals.blood_pressure.systolic}/${collectionData.body_vitals.blood_pressure.diastolic} ${collectionData.body_vitals.blood_pressure.unit}`
                                        : "-"
                                      : `${allFilesData?.vitals?.patient_bp} mm Hg` || "-"}
                                  </Typography>
                                </Box>

                                {/* Temperature */}
                                <Box>
                                  <Typography sx={styles.labelStyle}>
                                    TEMP
                                  </Typography>
                                  <Typography sx={styles.valueStyle}>
                                    {collectionData?.body_vitals
                                      ? collectionData?.body_vitals?.temperature?.value
                                        ? `${collectionData.body_vitals.temperature.value} ${collectionData.body_vitals.temperature.unit}`
                                        : "-"
                                      : `${allFilesData?.vitals?.patient_temp} °F` || "-"}
                                  </Typography>
                                </Box>

                                {/* Blood Glucose */}
                                <Box>
                                  <Typography sx={styles.labelStyle}>
                                    BLOOD GLUCOSE
                                  </Typography>
                                  <Typography sx={styles.valueStyle}>
                                    {collectionData?.body_vitals
                                      ? collectionData?.body_vitals?.blood_sugar?.value
                                        ? `${collectionData.body_vitals.blood_sugar.value} ${collectionData.body_vitals.blood_sugar.unit}`
                                        : "-"
                                      : allFilesData?.vitals?.patient_blood_glucose || "-"}
                                  </Typography>
                                </Box>

                                {/* Respiratory Rate */}
                                <Box>
                                  <Typography sx={styles.labelStyle}>
                                    RESPIRATORY RATE
                                  </Typography>
                                  <Typography sx={styles.valueStyle}>
                                    {collectionData?.body_vitals
                                      ? collectionData?.body_vitals?.respiratory_rate?.value
                                        ? `${collectionData.body_vitals.respiratory_rate.value} ${collectionData.body_vitals.respiratory_rate.unit}`
                                        : "-"
                                      : allFilesData?.vitals?.patient_respiratory_rate || "-"}
                                  </Typography>
                                </Box>
                              </Box>
                            </Box>
                          )}


                          {collectionData?.assignee && (
                            <Box
                              sx={{
                                background: "#ffffff",
                                p: 2,
                                borderRadius: "8px",
                                minHeight: "18%",
                                m: 2,
                              }}
                            >
                              <Typography variant="h6" fontWeight="600" mb={2}>
                                Collection Details
                              </Typography>

                              <Box sx={styles.gridLayout}>
                                {/* <Box display="flex" flexWrap="wrap"  alignItems= "center" gap={4}> */}
                                {/* Height */}
                                <Box>
                                  <Typography sx={styles.labelStyle}>
                                    DEVICE
                                  </Typography>

                                  <Typography sx={styles.valueStyle}>

                                    {(() => {
                                      try {
                                        const meta = JSON.parse(allFilesData?.meta_data || "{}");
                                        return meta?.device_name || "-";
                                      } catch (e) {
                                        return "-";
                                      }
                                    })()}
                                  </Typography>
                                </Box>

                                {/* Weight */}
                                <Box>
                                  <Typography sx={styles.labelStyle}>
                                    COLLECTED BY
                                  </Typography>
                                  <Typography sx={styles.valueStyle}>
                                    {collectionData?.assignee?.firstName || collectionData?.assignee?.lastName
                                      ? `${collectionData?.assignee?.firstName || ""} ${collectionData?.assignee?.lastName || ""}`.trim()
                                      : "-"}
                                  </Typography>
                                </Box>

                                {/* SPO2 */}
                                <Box>
                                  <Typography sx={styles.labelStyle}>
                                    COLLECTED ON
                                  </Typography>
                                  <Typography sx={styles.valueStyle}>
                                    {dayjs(collectionData?.assignee?.collectedOn).format("DD MMM YYYY, hh:mm a") || "-"}
                                  </Typography>
                                </Box>

                                {/* BP */}
                                <Box>
                                  <Typography sx={styles.labelStyle}>
                                    REQUESTED ON
                                  </Typography>
                                  <Typography sx={styles.valueStyle}>
                                    {allFilesData?.report_timestamp
                                      ? dayjs(Number(allFilesData.report_timestamp)).format("DD MMM YYYY, hh:mm a")
                                      : "-"
                                    }

                                  </Typography>
                                </Box>


                              </Box>
                            </Box>
                          )}


                          {/* Symptoms Section */}
                          {(collectionData?.symptoms || allFilesData?.vitals) &&
                            <Box
                              sx={{
                                background: "#ffffff",
                                p: 2,
                                borderRadius: "8px",
                                minHeight: "18%",
                                m: 2,
                              }}
                            >
                              <Typography variant="h6" fontWeight="600" mb={2}>
                                Symptoms
                              </Typography>


                              <Box sx={styles.gridLayout}>
                                {collectionData?.symptoms?.length > 0 ? (
                                  collectionData.symptoms.map((sym, idx) => (
                                    <Chip
                                      key={idx}
                                      label={sym}
                                      sx={{
                                        background: "#f1f1f1",
                                        px: 1.5,
                                        borderRadius: "12px",
                                      }}
                                    />
                                  ))
                                ) : allFilesData?.vitals?.patient_symptom ? (
                                  <Typography sx={{
                                    ...styles.valueStyle,
                                    gridColumn: "1 / -1", // Makes the text span the full width of the grid
                                    wordBreak: "break-word", // Ensures long words/commas don't overflow
                                    lineHeight: 1.5,
                                    textAlign: "justify"
                                  }}>
                                    {allFilesData?.vitals.patient_symptom}</Typography>
                                ) : (
                                  <Typography color="text.secondary">No symptoms</Typography>
                                )}
                              </Box>
                            </Box>
                          }

                          {/* Collection Agent */}
                          {collectionData?.medical_history_notes &&
                            <Box
                              sx={{
                                background: "#ffffff",
                                p: 2,
                                borderRadius: "8px",
                                minHeight: "18%",
                                m: 2,
                                mb: 4,
                              }}
                            >
                              <Typography variant="h6" fontWeight="600" mb={2}>
                                Medical history notes
                              </Typography>

                              <Box display="flex" flexWrap="wrap" gap={1} mt={1}>
                                <Typography color="text.secondary">
                                  {collectionData?.medical_history_notes || "—"}
                                </Typography>
                              </Box>
                            </Box>
                          }

                          <Box sx={{
                            background: "#ffffff",
                            p: 2,
                            borderRadius: "8px",
                            minHeight: "18%",
                            m: 2,
                            mb: 4,
                          }}>
                            <LeadQualityClassification data={allFilesData}></LeadQualityClassification>
                          </Box>

                        </Box>

                      </div>

                    </div>
                  </Panel>


                  {isLg ?
                    <><PanelResizeHandle />
                      <Panel defaultSize={30} minSize={20} className={panelStyles.Panel} >
                        {allFilesData ? (
                          <div >

                            <CustomReportInputForm
                              formKey={renderedFileIndex}
                              subsDetails={allFilesData.subscription_details}
                              businessName={allFilesData.business_name}
                              displayData={{ report_timestamp: allFilesData?.report_timestamp }}
                              reportData={allFilesData}
                              inputData={{
                                ...allFilesData?.user_data,
                                ...allFilesData?.interpretation_data,
                                interpretation_request_status:
                                  allFilesData?.interpretation_request_status
                              }}
                              handleReportInputFormSubmit={handleReportInputFormSubmit}
                              isLTData={LeadTrace}
                              leadReplica={replicaInterpret}
                            />

                          </div>
                        ) : (
                          ""
                        )}
                      </Panel>

                    </> :
                    <SwipeableDrawer
                      container={container}
                      anchor="bottom"
                      open={open}
                      onClose={toggleDrawer(false)}
                      onOpen={toggleDrawer(true)}
                      swipeAreaWidth={drawerBleeding}
                      disableSwipeToOpen={false}
                      ModalProps={{
                        keepMounted: true,
                      }}
                    >
                      <StyledBox
                        sx={{
                          position: 'absolute',
                          top: -drawerBleeding,
                          borderTopLeftRadius: 8,
                          borderTopRightRadius: 8,
                          visibility: 'visible',
                          backgroundColor: "#cccccc",
                          right: 0,
                          left: 0,
                        }}
                      >
                        <Puller />
                        <Typography sx={{ pt: 3, pb: 1, px: 2, color: 'text.secondary' }}>
                          {allFilesData?.interpretation_data?.completed_at ? (
                            <Typography variant="body2" textAlign="center">
                              {`By: `}<b>{allFilesData?.interpretation_data?.interpreter_details?.name}</b>
                              <Typography variant="body2" display="inline">
                                {` at `}<b>{dayjs(parseInt(allFilesData?.interpretation_data?.completed_at)).format("DD MMM hh:mm A")}</b>
                              </Typography>
                            </Typography>
                          ) :

                            <Typography variant="body2" textAlign="center">
                              Click to interpret
                            </Typography>
                          }
                        </Typography>
                      </StyledBox>
                      <StyledBox
                        sx={{
                          px: 2,
                          py: 2,
                          height: '100%',
                          overflow: 'auto',
                        }}
                      >
                        {allFilesData ? (
                          <CustomReportInputForm
                            formKey={renderedFileIndex}
                            displayData={{ report_timestamp: allFilesData?.report_timestamp }}
                            reportData={allFilesData}
                            inputData={{ ...allFilesData?.user_data, ...allFilesData?.interpretation_data, interpretation_request_status: allFilesData?.interpretation_request_status }}
                            handleReportInputFormSubmit={handleReportInputFormSubmit} />
                        ) : null}
                      </StyledBox>
                    </SwipeableDrawer>
                  }
                </PanelGroup>
              ) : importError ? (
                <div className={panelStyles.invalidReportBlock}>

                </div>
              ) : (
                ""
              )
            }
          </Grid >
        )}
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </Grid >

      <Dialog open={openInterpretationRevokeDialog} onClose={(event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        setOpenInterpretationRevokeDialog(false)

      }}>
        <DialogTitle>Interpretation Check</DialogTitle>

        <DialogContent>
          <Typography>
            {interpretationRevokeData.message}
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleExit} color="error">
            Exit
          </Button>
          <Button onClick={handleContinue} variant="contained">
            Continue
          </Button>
        </DialogActions>
      </Dialog>

    </Root>
  );
}

export default Custominterpretation;